import React from 'react'
import Sidebar from '../components/Sidebar'

const Dashboard = () => {
  return (
    <div className='d-flex'>
      <Sidebar />
      <div>
        Content Dashboard
      </div>
    </div>
  )
}

export default Dashboard